// HKDSE 2024 Paper 1 Knowledge Graph Samples - Combined
// Merged from hkdse2024Samples.js

import { hkdse2024Samples } from './hkdse2024Samples.js';

export const hkdse2024Samples_combined = {
  ...hkdse2024Samples
};

// Export individual parts for backward compatibility
export { hkdse2024Samples }; 